
import { useState, useRef, KeyboardEvent } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Send } from "lucide-react";

interface ChatInputProps {
  onSendMessage: (message: string) => void;
  isLoading: boolean;
  inputRef?: React.RefObject<HTMLInputElement>;
}

export const ChatInput = ({ onSendMessage, isLoading, inputRef }: ChatInputProps) => {
  const [inputValue, setInputValue] = useState("");
  const localInputRef = useRef<HTMLInputElement>(null);
  const actualInputRef = inputRef || localInputRef;

  const handleSend = () => {
    if (inputValue.trim() === "" || isLoading) return;
    onSendMessage(inputValue);
    setInputValue("");
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="p-3 border-t">
      <div className="flex gap-2">
        <Input
          ref={actualInputRef}
          placeholder="Type your message..."
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={isLoading}
          className="flex-1"
        />
        <Button
          onClick={handleSend}
          disabled={isLoading || inputValue.trim() === ""}
          size="icon"
          className="bg-digger-blue hover:bg-digger-blue-light"
        >
          <Send className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};
